import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const trail = css`
  width: auto;
`

export const slotButton = css`
  border-radius: 0;
  border: none;

  && {
    /* Стиль из slot перезатёрся из-за использования Component={Button} */
    min-block-size: ${spacing(7)};
  }

  ::before {
    content: none;
  }
`
